import { render, staticRenderFns } from "./PromotionsIcon.vue?vue&type=template&id=ec371358&"
import script from "./PromotionsIcon.vue?vue&type=script&lang=js&"
export * from "./PromotionsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports